// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saplan-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media (max-width: 768px) {
  .saplan-form-container {
    padding: 1rem;
  }
}
.saplan-form-container .no-spinner::-webkit-outer-spin-button,
.saplan-form-container .no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.saplan-form-container .toast {
  position: fixed;
  top: 1rem;
  right: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
  color: white;
  font-weight: 500;
  z-index: 1000;
  animation: toast-slide-in 0.3s ease-out;
}
.saplan-form-container .toast.success {
  background-color: #10b981;
}
.saplan-form-container .toast.error {
  background-color: #ef4444;
}
.saplan-form-container .saplan-form-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: plan-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .saplan-form-container .saplan-form-wrapper {
    padding: 1rem;
    width: 100%;
  }
}
.saplan-form-container .saplan-form-header {
  text-align: center;
  margin-bottom: 0.5rem;
}
.saplan-form-container .saplan-form-header .saplan-form-title {
  font-size: 1.6rem;
  font-weight: 500;
  color: #374151;
  margin: 0;
}
@media (max-width: 768px) {
  .saplan-form-container .saplan-form-header .saplan-form-title {
    font-size: 1.25rem;
  }
}
.saplan-form-container .saplan-form-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.saplan-form-container form {
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
  animation: none;
  width: 100%;
}
@media (max-width: 768px) {
  .saplan-form-container form {
    padding: 0;
    width: 100%;
  }
}
.saplan-form-container > h1 {
  display: none;
}
.saplan-form-container .form-section {
  padding-bottom: 1.5rem;
}
.saplan-form-container .form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.saplan-form-container .form-section h3 {
  font-size: 1.125rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.saplan-form-container .form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.saplan-form-container .form-row:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .saplan-form-container .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.saplan-form-container .form-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 0rem;
}
.saplan-form-container .form-group:last-child {
  margin-bottom: 0;
}
.saplan-form-container .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.saplan-form-container .form-group label .saplan-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.saplan-form-container .form-group input,
.saplan-form-container .form-group select,
.saplan-form-container .form-group textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  min-height: 2.5rem;
}
.saplan-form-container .form-group input:focus,
.saplan-form-container .form-group select:focus,
.saplan-form-container .form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.saplan-form-container .form-group input:hover:not(:focus),
.saplan-form-container .form-group select:hover:not(:focus),
.saplan-form-container .form-group textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.saplan-form-container .form-group input::placeholder,
.saplan-form-container .form-group select::placeholder,
.saplan-form-container .form-group textarea::placeholder {
  color: #9ca3af;
}
.saplan-form-container .form-group input:disabled,
.saplan-form-container .form-group select:disabled,
.saplan-form-container .form-group textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.saplan-form-container .form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.saplan-form-container .form-group textarea {
  min-height: 100px;
  resize: vertical;
  padding: 0.5rem;
}
.saplan-form-container .form-group .error {
  color: #ef4444;
  font-size: 0.75rem;
  margin-top: 0.25rem;
  font-weight: 500;
}
.saplan-form-container .rights-checkboxes {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}
@media (max-width: 768px) {
  .saplan-form-container .rights-checkboxes {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 0.75rem;
  }
}
.saplan-form-container .checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.saplan-form-container .checkbox-group label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  text-transform: capitalize;
  margin-bottom: 0;
  cursor: pointer;
}
.saplan-form-container .checkbox-group input[type=checkbox] {
  appearance: none;
  width: 50px;
  height: 24px;
  background-color: #d1d5db;
  border: none;
  border-radius: 24px;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 24px;
}
.saplan-form-container .checkbox-group input[type=checkbox]::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.saplan-form-container .checkbox-group input[type=checkbox]:checked {
  background-color: var(--primary-color, #3b82f6);
}
.saplan-form-container .checkbox-group input[type=checkbox]:checked::before {
  transform: translateX(26px);
}
.saplan-form-container .checkbox-group input[type=checkbox]:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.saplan-form-container .checkbox-group input[type=checkbox]:hover:not(:checked) {
  background-color: #9ca3af;
}
.saplan-form-container .checkbox-group input[type=checkbox]:hover:checked {
  background-color: #2563eb;
}
.saplan-form-container button[type=submit] {
  width: 100%;
  padding: 0.75rem 1.5rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 1.5rem;
  min-height: 2.75rem;
}
.saplan-form-container button[type=submit]:focus {
  outline: none;
}
.saplan-form-container button[type=submit]:hover {
  background-color: #005a9a;
}
.saplan-form-container button[type=submit]:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
@media (max-width: 768px) {
  .saplan-form-container button[type=submit] {
    padding: 0.625rem 1.25rem;
    font-size: 0.8125rem;
  }
}
.saplan-form-container .loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  font-size: 1.125rem;
  color: #6b7280;
}

@keyframes plan-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes toast-slide-in {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@media (max-width: 768px) {
  .saplan-form-container .saplan-form-wrapper {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .saplan-form-container {
    padding: 0.5rem;
  }
  .saplan-form-container .saplan-form-wrapper {
    padding: 0.75rem;
  }
  .saplan-form-container .saplan-form-header .saplan-form-title {
    font-size: 1.125rem;
  }
  .saplan-form-container .form-group input,
  .saplan-form-container .form-group select,
  .saplan-form-container .form-group textarea {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .saplan-form-container button[type=submit] {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
  .saplan-form-container .rights-checkboxes {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 0.5rem;
  }
}
@media print {
  .saplan-form-container {
    background: white;
    padding: 0;
  }
  .saplan-form-container .saplan-form-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .saplan-form-container button,
  .saplan-form-container .toast {
    display: none;
  }
}
.saplan-form-container input:focus-visible,
.saplan-form-container select:focus-visible,
.saplan-form-container textarea:focus-visible,
.saplan-form-container button:focus-visible {
  outline: 2px solid var(--primary-color, #3b82f6);
  outline-offset: 2px;
}
.saplan-form-container .checkbox-group input[type=checkbox]:focus-visible {
  outline: 2px solid var(--primary-color, #3b82f6);
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/forms/SAPlanForm/SAPlanForm.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAEE;EATF;IAUI,aAAA;EACF;AACF;AAAE;;EAEA,wBAAA;EACA,SAAA;AAEF;AAEE;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,uCAAA;AAAJ;AAEI;EACE,yBAAA;AAAN;AAGI;EACE,yBAAA;AADN;AAME;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,0CAAA;EACA,UAAA;AAJJ;AAMI;EATF;IAUI,aAAA;IACA,WAAA;EAHJ;AACF;AAOE;EACE,kBAAA;EACA,qBAAA;AALJ;AAOI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AALN;AAOM;EANF;IAOI,kBAAA;EAJN;AACF;AASE;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAPJ;AAWE;EACE,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AATJ;AAWI;EARF;IASI,UAAA;IACA,WAAA;EARJ;AACF;AAYE;EACE,aAAA;AAVJ;AAcE;EAEE,sBAAA;AAbJ;AAeI;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAbN;AAgBI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AAdN;AAmBE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAjBJ;AAmBI;EACE,gBAAA;AAjBN;AAoBI;EATF;IAUI,sBAAA;IACA,WAAA;EAjBJ;AACF;AAqBE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAnBJ;AAqBI;EACE,gBAAA;AAnBN;AAsBI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AApBN;AAqBM;EACE,cAAA;EACA,oBAAA;AAnBR;AAwBI;;;EAGE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAtBN;AAwBM;;;EACE,aAAA;EACA,2CAAA;EACA,6CAAA;AApBR;AAuBM;;;EACE,qBAAA;AAnBR;AAsBM;;;EACE,cAAA;AAlBR;AAqBM;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAjBR;AAqBI;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAnBN;AAsBI;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;AApBN;AAuBI;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AArBN;AA0BE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AAxBJ;AA0BI;EANF;IAOI,4DAAA;IACA,YAAA;EAvBJ;AACF;AA0BE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAxBJ;AA0BI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;AAxBN;AA4BI;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AA1BN;AA4BM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AA1BR;AA6BM;EACE,+CAAA;AA3BR;AA6BQ;EACE,2BAAA;AA3BV;AA+BM;EACE,aAAA;EACA,6CAAA;AA7BR;AAgCM;EACE,yBAAA;AA9BR;AAiCM;EACE,yBAAA;AA/BR;AAqCE;EACE,WAAA;EACA,uBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAnCJ;AAqCI;EACE,aAAA;AAnCN;AAqCI;EACE,yBAAA;AAnCN;AAsCI;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AApCN;AAuCI;EA5BF;IA6BI,yBAAA;IACA,oBAAA;EApCJ;AACF;AAwCE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAtCJ;;AA2CA;EACE;IACE,UAAA;IACA,2BAAA;EAxCF;EA2CA;IACE,UAAA;IACA,wBAAA;EAzCF;AACF;AA4CA;EACE;IACE,UAAA;IACA,2BAAA;EA1CF;EA6CA;IACE,UAAA;IACA,wBAAA;EA3CF;AACF;AA+CA;EAEI;IACE,WAAA;EA9CJ;AACF;AAkDA;EACE;IACE,eAAA;EAhDF;EAkDE;IACE,gBAAA;EAhDJ;EAoDI;IACE,mBAAA;EAlDN;EAuDI;;;IAGE,iBAAA;IACA,oBAAA;EArDN;EAyDE;IACE,oBAAA;IACA,oBAAA;EAvDJ;EA0DE;IACE,4DAAA;IACA,WAAA;EAxDJ;AACF;AA6DA;EACE;IACE,iBAAA;IACA,UAAA;EA3DF;EA6DE;IACE,gBAAA;IACA,sBAAA;EA3DJ;EA8DE;;IAEE,aAAA;EA5DJ;AACF;AAkEE;;;;EAIE,gDAAA;EACA,mBAAA;AAhEJ;AAmEE;EACE,gDAAA;EACA,mBAAA;AAjEJ","sourcesContent":["// Main Container\n.saplan-form-container {\n  min-height: calc(100vh - 118px);\n  background: var(--grey-shade-three);\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n  .no-spinner::-webkit-outer-spin-button,\n.no-spinner::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n  // Toast styling (if you add toast functionality later)\n  .toast {\n    position: fixed;\n    top: 1rem;\n    right: 1rem;\n    padding: 0.75rem 1rem;\n    border-radius: 0.375rem;\n    color: white;\n    font-weight: 500;\n    z-index: 1000;\n    animation: toast-slide-in 0.3s ease-out;\n\n    &.success {\n      background-color: #10b981;\n    }\n\n    &.error {\n      background-color: #ef4444;\n    }\n  }\n\n  // Form Wrapper - New wrapper structure\n  .saplan-form-wrapper {\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 1.5rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    animation: plan-form-fade-in 0.3s ease-out;\n    width: 70%;\n\n    @media (max-width: 768px) {\n      padding: 1rem;\n      width: 100%;\n    }\n  }\n\n  // Header styling (moved inside wrapper)\n  .saplan-form-header {\n    text-align: center;\n    margin-bottom: 0.5rem;\n\n    .saplan-form-title {\n      font-size: 1.6rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0;\n\n      @media (max-width: 768px) {\n        font-size: 1.25rem;\n      }\n    }\n  }\n\n  // Divider styling\n  .saplan-form-divider {\n    border: none;\n    border-top: 1px solid #e5e7eb;\n    margin: 1.5rem 0;\n  }\n\n  // Form styling - Updated to work with wrapper\n  form {\n    padding: 0; // Remove padding since it's now in wrapper\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    animation: none;\n    width: 100%;\n\n    @media (max-width: 768px) {\n      padding: 0;\n      width: 100%;\n    }\n  }\n\n  // Hide old h1 outside wrapper (if any remains)\n  > h1 {\n    display: none;\n  }\n\n  // Form sections for better organization\n  .form-section {\n    //margin-bottom: 1.5rem;\n    padding-bottom: 1.5rem;\n\n    &:last-of-type {\n      border-bottom: none;\n      margin-bottom: 0;\n      padding-bottom: 0;\n    }\n\n    h3 {\n      font-size: 1.125rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0 0 1rem 0;\n      padding-bottom: 0.5rem;\n      border-bottom: 1px solid #e5e7eb;\n    }\n  }\n\n  // Form rows for side-by-side layout\n  .form-row {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n  }\n\n  // Individual form groups\n  .form-group {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 0rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    label {\n      display: block;\n      margin-bottom: 0.5rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      color: #374151;\n      .saplan-form-required {\n        color: #ef4444;\n        margin-left: 0.25rem;\n      }\n    }\n\n    // Input styling to match UserForm\n    input,\n    select,\n    textarea {\n      width: 100%;\n      padding: 0.5rem;\n      border: 1px solid #d1d5db;\n      border-radius: 0.25rem;\n      font-size: 0.875rem;\n      font-family: inherit;\n      color: #374151;\n      background: #ffffff;\n      box-sizing: border-box;\n      min-height: 2.5rem;\n\n      &:focus {\n        outline: none;\n        border-color: var(--primary-color, #3b82f6);\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n\n      &:hover:not(:focus) {\n        border-color: #9ca3af;\n      }\n\n      &::placeholder {\n        color: #9ca3af;\n      }\n\n      &:disabled {\n        background-color: #f9fafb;\n        color: #6b7280;\n        cursor: not-allowed;\n      }\n    }\n\n    select {\n      appearance: none;\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n      background-position: right 0.5rem center;\n      background-repeat: no-repeat;\n      background-size: 1.5rem 1.5rem;\n      padding-right: 2.5rem;\n    }\n\n    textarea {\n      min-height: 100px;\n      resize: vertical;\n      padding: 0.5rem;\n    }\n\n    .error {\n      color: #ef4444;\n      font-size: 0.75rem;\n      margin-top: 0.25rem;\n      font-weight: 500;\n    }\n  }\n\n  // Rights section styling to match visibility toggles\n  .rights-checkboxes {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: 1rem;\n    margin-top: 1rem;\n\n    @media (max-width: 768px) {\n      grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n      gap: 0.75rem;\n    }\n  }\n\n  .checkbox-group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n\n    label {\n      font-size: 0.875rem;\n      font-weight: 500;\n      color: #374151;\n      text-transform: capitalize;\n      margin-bottom: 0;\n      cursor: pointer;\n    }\n\n    // Custom checkbox styling to match toggle switches\n    input[type=\"checkbox\"] {\n      appearance: none;\n      width: 50px;\n      height: 24px;\n      background-color: #d1d5db;\n      border: none;\n      border-radius: 24px;\n      position: relative;\n      cursor: pointer;\n      transition: all 0.3s ease;\n      min-height: 24px;\n\n      &::before {\n        content: \"\";\n        position: absolute;\n        height: 18px;\n        width: 18px;\n        left: 3px;\n        top: 3px;\n        background-color: white;\n        border-radius: 50%;\n        transition: all 0.3s ease;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n      }\n\n      &:checked {\n        background-color: var(--primary-color, #3b82f6);\n\n        &::before {\n          transform: translateX(26px);\n        }\n      }\n\n      &:focus {\n        outline: none;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n\n      &:hover:not(:checked) {\n        background-color: #9ca3af;\n      }\n\n      &:hover:checked {\n        background-color: #2563eb;\n      }\n    }\n  }\n\n  // Submit button styling to match UserForm\n  button[type=\"submit\"] {\n    width: 100%;\n    padding: 0.75rem 1.5rem;\n    background-color: var(--primary-color);\n    color: white;\n    border: none;\n    border-radius: 0.375rem;\n    font-weight: 500;\n    font-size: 0.875rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    margin-top: 1.5rem;\n    min-height: 2.75rem;\n\n    &:focus {\n      outline: none;\n    }\n    &:hover {\n      background-color: #005a9a;\n    }\n\n    &:disabled {\n      background-color: #d1d5db;\n      color: #9ca3af;\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n\n    @media (max-width: 768px) {\n      padding: 0.625rem 1.25rem;\n      font-size: 0.8125rem;\n    }\n  }\n\n  // Loading state\n  .loading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 200px;\n    font-size: 1.125rem;\n    color: #6b7280;\n  }\n}\n\n// Animations\n@keyframes plan-form-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes toast-slide-in {\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n// Responsive design improvements\n@media (max-width: 768px) {\n  .saplan-form-container {\n    .saplan-form-wrapper {\n      width: 100%;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .saplan-form-container {\n    padding: 0.5rem;\n\n    .saplan-form-wrapper {\n      padding: 0.75rem;\n    }\n\n    .saplan-form-header {\n      .saplan-form-title {\n        font-size: 1.125rem;\n      }\n    }\n\n    .form-group {\n      input,\n      select,\n      textarea {\n        padding: 0.375rem;\n        font-size: 0.8125rem;\n      }\n    }\n\n    button[type=\"submit\"] {\n      padding: 0.5rem 1rem;\n      font-size: 0.8125rem;\n    }\n\n    .rights-checkboxes {\n      grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n      gap: 0.5rem;\n    }\n  }\n}\n\n// Print styles\n@media print {\n  .saplan-form-container {\n    background: white;\n    padding: 0;\n\n    .saplan-form-wrapper {\n      box-shadow: none;\n      border: 1px solid #000;\n    }\n\n    button,\n    .toast {\n      display: none;\n    }\n  }\n}\n\n// Focus visible improvements for accessibility\n.saplan-form-container {\n  input:focus-visible,\n  select:focus-visible,\n  textarea:focus-visible,\n  button:focus-visible {\n    outline: 2px solid var(--primary-color, #3b82f6);\n    outline-offset: 2px;\n  }\n\n  .checkbox-group input[type=\"checkbox\"]:focus-visible {\n    outline: 2px solid var(--primary-color, #3b82f6);\n    outline-offset: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
